import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Strips accents/diacritics from text for accent-insensitive search.
 * Mirrors PostgreSQL unaccent() behaviour used on the backend.
 */
export const normalizeSearch = (text: string): string =>
  text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
